<ng-template [ngIf]="data && data.length">
  {{eerste}}
  <ng-container *ngIf="data.length > 1">
    <mark><span>+{{data.length - 1}}</span></mark>
    <div>{{rest}}</div>
  </ng-container>
</ng-template>
